//React
import React, { useEffect, useState, useContext, useRef } from "react";

//Material
import { Grid, Switch, FormControlLabel, Tooltip } from "@material-ui/core";
import Grow from "@material-ui/core/Grow";

//OurComponents
import HeaderModule from "../../../components/header/HeaderModule";
import Card from "../../../components/cards/Card";
import Btn from "../../../components/buttons/Btn";
import Chip from "../../../components/basics/Chip";

//Styled Components
import {
  NotaContainer,
  StatusControl,
  Cabecalho,
  Remetente,
  Itens,
  Secundarios,
  MainActions,
} from "./styles/Emissao";

import ListAltIcon from "@material-ui/icons/ListAlt";

//Childrens
import AccordionEmissaoCabecalho from "./children/AccordionEmissaoCabecalho";
import AccordionEmissaoRemetente from "./children/AccordionEmissaoRemetente";
import AccordionEmissaoItens from "./children/AccordionEmissaoItens";
import AccordionEmissaoSecundarios from "./children/AccordionEmissaoSecundarios";

import useEmissaoController from "./controllers/EmissaoController";
import { EmissaoContext } from "./contexts/EmissaoContext";
import { ParametrosProdutoContext } from "./contexts/ParametrosProdutoContext";
import { QueryParamsContext } from "../../../context/QueryParamsContext";

import { findLocaisEstoques } from "../../../repositories/qerpapi/erp/estoque/v1/LocalEstoqueRepository";
import { findNcm } from "../../../repositories/qerpapi/erp/nf/v1/NcmRepository";
import { findCfops } from "../../../repositories/qerpapi/erp/nf/v1/CfopRepository";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import Loading from "../../../components/basics/Loading";
import ModalEmissaoMontAutomatica from "./children/ModalEmissaoMontAutomatica";
import ModalCancelamentoNfe from "./children/ModalCancelamentoNfe";
import ModalCartaCorrecao from "./children/ModalCartaCorrecao";
import ModalAvisoDescontinuacaoEmissaoNfe from "./children/ModalAvisoDescontinuacaoEmissaoNfe";
import useNfeController from "./controllers/NfeController";
import { findBandeiras } from "../../../repositories/qerpapi/erp/financeiro/BandeirasRepository";
import { useHistory } from "react-router";
import { validadeCertificado } from "../../../repositories/qerpapi/erp/prouser/v2/EmpresaRepository";
import { findOrigem } from "../../../repositories/qerpapi/erp/vendas/v1/OrigemRepository";
import InputTime from "../../../components/inputs/InputTime";
import TextField from "../../../components/basics/TextFieldErp";
import useCalculosTributacao from "./controllers/RulesEmissaoCalculosTributacao";
import { findEstado } from "../../../repository/ERP/prouser/EstadoService";
import { findMunicipio } from "../../../repository/ERP/prouser/MunicipioService";
import { findOperadoras } from "../../../repositories/qerpapi/erp/financeiro/OperadorasRepository";
import { findContabilista } from "../../../repositories/qerpapi/erp/prouser/v1/ContabilistaRepository";
import { getSummaryDocumentsConfig } from "../../../repositories/qerpapi/v3/documentosfiscais";
import { notify } from "../../../utils/notify";
import queryString from "query-string";
import { GlobalVariables } from "../../../GlobalVariables";

const EmissaoView = ({ location }) => {
  const saveButtonRef = useRef(null);
  const {
    handleSaveNota,
    handleTransmitNfe,
    handleOpenNfe,
    clearNfe,
    handleOpenCloneNfe,
    handleGetSeriesOptions,
    handleOpenSalesOrder,
  } = useEmissaoController();

  const { getSuccessStats } = useCalculosTributacao();

  const { handleDownloadXmlNota, handleDownloadDanfe } = useNfeController();

  const {
    nfeId,
    nfeLotes,
    nfeStatus,
    setNfeStatus,
    nfeListStockLocation,
    setNfeListStockLocation,
    setNfeListNcm,
    setNfeListCfop,
    setNfeListBandeiras,
    setNfeListOperadoras,
    setHeaderIssueType,
    setHeaderCfop,
    mainLoading,
    getSeriesLoading,
    setMainLoading,
    daysCertificate,
    setDaysCertificate,
    nfeMontageType,
    setNfeListReasonIntermed,
    headerTime,
    setHeaderTime,
    headerDateJL,
    setHeaderDateJL,
    nfeError,
    setHeaderIssueTime,
    headerTypeNfe,
    forceProduction,
    setForceProduction,
    nfeValidXml,
    listUf,
    setListUf,
    listCounty,
    setListCounty,
    nfeListCfop,
    setLoadingInputs,
    firstSaveDiBlock,
    visualizationOnly,
    setFirstSaveDiBlock,
    setTypeMontage,
    setXmlAuthorizedList,
    cloneLoading,
    defaultListModels,
    listModels,
    setListModels,
    headerModel,
    setHeaderModel,
    salesOrderLoading,
    headerSeriesOptions,
    openNfeLoading,
  } = useContext(EmissaoContext);

  const { queryParams, tempQueryParams } = useContext(QueryParamsContext);
  const { setProductDataStock } = useContext(ParametrosProdutoContext);

  const successStats = getSuccessStats();

  const [openAutomatic, setOpenAutomatic] = useState(false);
  const [openCancelNfe, setOpenCancelNfe] = useState(false);
  const [openCC, setOpenCC] = useState(false);
  const [openAvisoDescontinuacao, setOpenAvisoDescontinuacao] =
    useState(true);

  const { push } = useHistory();

  useEffect(() => {
    setForceProduction(false);
    setFirstSaveDiBlock(false);
    setTypeMontage("");
  }, [setFirstSaveDiBlock, setForceProduction, setTypeMontage]);

  useEffect(() => {
    if (queryParams.id && !location.state) {
      setHeaderIssueType(queryParams.tipoemissaonfe);
      setHeaderCfop(queryParams.cfopsaidapadrao);
    }
  }, [
    queryParams.id,
    location.state,
    queryParams.tipoemissaonfe,
    queryParams.cfopsaidapadrao,
    setHeaderIssueType,
    setHeaderCfop,
  ]);

  useEffect(() => {
    setHeaderTime(new Date());
    setHeaderIssueTime(new Date());
  }, [setHeaderTime, setHeaderIssueTime]);

  useEffect(() => {
    (async () => {
      const validCertificate = await validadeCertificado(
        queryParams.empresa_cnpj
      );
      if (validCertificate.success) {
        setDaysCertificate(validCertificate.data.daysRemaining);
      }
    })();
  }, [queryParams.empresa_cnpj, setDaysCertificate]);

  useEffect(() => {
    if (!queryParams?.empresa_cnpj) return;
    try {
      setMainLoading(true);
      (async () => {
        const callbackCfop = await findCfops({
          empresa_cnpj: queryParams.empresa_cnpj,
          per_page: "999",
          where: {
            ativo: "S",
          },
        });
        if (callbackCfop.data) {
          setNfeListCfop(callbackCfop.data);
        }
        setMainLoading(false);
      })();
    } catch (error) {
      console.error(error);
      setMainLoading(false);
    }
  }, [queryParams?.empresa_cnpj, setNfeListCfop, setMainLoading]);

  useEffect(() => {
    (async () => {
      setMainLoading(true);
      try {
        const callback = await findLocaisEstoques(queryParams.empresa_cnpj);
        if (callback.data) {
          setNfeListStockLocation(callback.data);
          setProductDataStock(callback.data[0]);
        }
        setMainLoading(false);
      } catch (error) {
        console.error(error);
        setMainLoading(false);
      }
    })();
  }, [
    queryParams.empresa_cnpj,
    setNfeListStockLocation,
    setProductDataStock,
    setMainLoading,
  ]);

  useEffect(() => {
    (async () => {
      setMainLoading(true);
      try {
        const callback = await findNcm(queryParams.empresa_cnpj);
        if (callback.data) {
          setNfeListNcm(callback.data);
        }
        setMainLoading(false);
      } catch (error) {
        console.error(error);
        setMainLoading(false);
      }
    })();
  }, [queryParams.empresa_cnpj, setNfeListNcm, setMainLoading]);

  useEffect(() => {
    (async () => {
      try {
        setMainLoading(true);
        const callback = await findBandeiras(queryParams.empresa_cnpj);
        if (callback.data) {
          setNfeListBandeiras(callback.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    })();
  }, [queryParams.empresa_cnpj, setMainLoading, setNfeListBandeiras]);

  useEffect(() => {
    if (
      location?.state?.id &&
      location?.state?.operation &&
      listUf.length &&
      listCounty.length &&
      nfeListCfop.length
    ) {
      if (location?.state?.operation === "clone") {
        handleOpenCloneNfe(location?.state?.id);
      } else if (location?.state?.operation === "edit") {
        handleOpenNfe(location?.state?.id);
      }
    }
    // eslint-disable-next-line
  }, [location?.state, listUf, listCounty, nfeListCfop]);

  useEffect(() => {
    if (
      !listUf.length ||
      !listCounty.length ||
      !nfeListCfop.length ||
      !nfeListStockLocation.length ||
      !tempQueryParams?.operation ||
      !tempQueryParams?.saleId ||
      !listModels?.length ||
      !queryParams?.empresa_cnpj ||
      !queryParams?.id ||
      !queryParams?.cfopsaidapadrao ||
      !headerSeriesOptions?.length
    )
      return;

    if (tempQueryParams?.operation === "salesOrder") {
      handleOpenSalesOrder({
        saleId: tempQueryParams?.saleId,
        clientDocument: tempQueryParams?.clientDocument || "",
        saveButtonRef: saveButtonRef,
      });
    }
  }, [
    handleOpenSalesOrder,
    headerSeriesOptions?.length,
    listCounty.length,
    listModels?.length,
    listUf.length,
    nfeListCfop.length,
    nfeListStockLocation.length,
    queryParams?.cfopsaidapadrao,
    queryParams?.empresa_cnpj,
    queryParams?.id,
    tempQueryParams?.clientDocument,
    tempQueryParams?.operation,
    tempQueryParams?.saleId,
  ]);

  useEffect(() => {
    (async () => {
      try {
        setMainLoading(true);

        const callbackOrigem = await findOrigem(queryParams.empresa_cnpj);

        if (callbackOrigem.success && callbackOrigem.data.length) {
          setNfeListReasonIntermed(callbackOrigem.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    })();
  }, [queryParams.empresa_cnpj, setNfeListReasonIntermed, setMainLoading]);

  useEffect(() => {
    if (listCounty.length) return;
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listCounty: true,
        }));

        const resultCounty = await findMunicipio(queryParams.empresa_cnpj);
        if (resultCounty.success) setListCounty(resultCounty.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listCounty: false,
        }));
      }
    })();
    // eslint-disable-next-line
  }, [queryParams.empresa_cnpj, setListCounty, setLoadingInputs]);

  useEffect(() => {
    if (listUf.length) return;
    (async () => {
      try {
        setLoadingInputs((current) => ({
          ...current,
          listUf: true,
        }));
        const resultUf = await findEstado(queryParams.empresa_cnpj);
        if (resultUf.success) setListUf(resultUf.data);
      } catch (error) {
      } finally {
        setLoadingInputs((current) => ({
          ...current,
          listUf: false,
        }));
      }
    })();
    // eslint-disable-next-line
  }, [queryParams.empresa_cnpj, setListUf, setLoadingInputs]);

  useEffect(() => {
    (async () => {
      try {
        setMainLoading(true);
        const callback = await findOperadoras(queryParams.empresa_cnpj);

        if (callback.data) {
          setNfeListOperadoras(callback.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    })();
  }, [queryParams.empresa_cnpj, setMainLoading, setNfeListOperadoras]);

  useEffect(() => {
    if (
      queryParams.paramutilizacontabilistaautorizadoxmlnfe === "SIM" &&
      !location.state
    )
      (async () => {
        try {
          setMainLoading(true);
          const callback = await findContabilista({
            empresa_cnpj: queryParams.empresa_cnpj,
            where: { empresas_id: queryParams.id },
          });

          if (callback.data?.[0]?.cnpj_cpf) {
            const document = callback.data[0].cnpj_cpf;
            setXmlAuthorizedList([
              {
                index: 0,
                documento: document,
                tipo: document.length > 11 ? "CNPJ" : "CPF",
              },
            ]);
          }
        } catch (error) {
          console.error(error);
        } finally {
          setMainLoading(false);
        }
      })();
  }, [
    queryParams.id,
    queryParams.empresa_cnpj,
    queryParams.paramutilizacontabilistaautorizadoxmlnfe,
    setMainLoading,
    setXmlAuthorizedList,
    location.state,
  ]);

  useEffect(() => {
    if (!queryParams?.empresa_id || !!location?.state || !listModels?.length)
      return;

    handleGetSeriesOptions({
      production: forceProduction,
    });
    // eslint-disable-next-line
  }, [
    location?.state,
    handleGetSeriesOptions,
    queryParams.empresa_id,
    forceProduction,
    listModels,
  ]);

  useEffect(() => {
    if (!queryParams?.empresa_id) return;

    (async () => {
      try {
        setMainLoading(true);

        const summaryDocumentsResponse = await getSummaryDocumentsConfig({
          companyId: queryParams.empresa_id,
        });

        if (!summaryDocumentsResponse?.success)
          return notify(
            summaryDocumentsResponse?.message ||
              "Não foi possível validar os documentos fiscais!",
            true,
            "error"
          );

        const { data } = summaryDocumentsResponse;

        let copyListModels = [...defaultListModels];

        const fiscalDocuments = {
          nfe: {
            model: "55",
            active: data.nfe,
          },
          nfce: {
            model: "65",
            active: data.nfce,
          },
        };

        Object.values(fiscalDocuments).forEach((document) => {
          if (!document.active) {
            copyListModels = copyListModels.filter(
              (model) => model.value !== document.model
            );
          }
        });

        if (copyListModels.length === 1) {
          setHeaderModel(copyListModels[0]);
        }

        setListModels(copyListModels);
      } catch (error) {
        console.error(error);
        notify(
          "Não foi possível validar os documentos fiscais!",
          true,
          "error"
        );
      } finally {
        setMainLoading(false);
      }
    })();
  }, [
    setMainLoading,
    queryParams.empresa_id,
    defaultListModels,
    setListModels,
    setHeaderModel,
  ]);

  const jsonNfSituation = {
    R: <Chip bgcolor="green" textcolor="white" label="TRANSMITIDA" />,
    D: <Chip bgcolor="secondary" textcolor="black" label="EM DIGITAÇÃO" />,
    C: <Chip bgcolor="darkred" textcolor="white" label="CANCELADA" />,
    T: <Chip bgcolor="tertiary" textcolor="white" label="COMPLEMENTAR" />,
    I: <Chip bgcolor="orange" textcolor="white" label="INUTILIZADA" />,
    G: <Chip bgcolor="orange" textcolor="white" label="DENEGADA" />,
  };

  return (
    <>
      <ModalAvisoDescontinuacaoEmissaoNfe
        open={openAvisoDescontinuacao}
        setOpen={setOpenAvisoDescontinuacao}
      />
      {openAutomatic && (
        <ModalEmissaoMontAutomatica
          setModalAutomaticaOpen={setOpenAutomatic}
          modalAutomaticaOpen={openAutomatic}
        />
      )}
      {openCancelNfe && (
        <ModalCancelamentoNfe
          modalCancelamentoOpen={openCancelNfe}
          setModalCancelamentoOpen={setOpenCancelNfe}
          setLoading={setMainLoading}
          emissao
          setNfeStatus={setNfeStatus}
          nfeId={nfeId}
        />
      )}
      {openCC && (
        <ModalCartaCorrecao
          nfeId={nfeId}
          modalCartaCorrecaoOpen={openCC}
          setModalCartaCorrecaoOpen={setOpenCC}
          setMainLoading={setMainLoading}
        />
      )}
      <Loading
        open={
          mainLoading ||
          cloneLoading ||
          getSeriesLoading ||
          salesOrderLoading ||
          openNfeLoading
        }
      />
      <HeaderModule
        title="NOTA FISCAL ELETRÔNICA (NFe)"
        titleXs={5}
        childXs={7}
        videoId={GlobalVariables.screenVideosIds.nfePainel}
        receivedChild={
          <Grid item container xs={9} alignItems="center" spacing={1}>
            {process.env.REACT_APP_AMBIENTE !== "MASTER" && (
              <Grid item xs={4}>
                <FormControlLabel
                  label="Forçar Produção"
                  value="end"
                  control={
                    <Switch
                      checked={forceProduction}
                      onChange={({ target: { checked } }) => {
                        setForceProduction((current) => !current);
                      }}
                      color="primary"
                    />
                  }
                />
              </Grid>
            )}
            <Grid item xs={4}>
              <div style={{ height: 45, display: "flex" }}>
                <Btn
                  startIcon={<ListAltIcon />}
                  style={{ width: "100%", fontSize: "12px" }}
                  label="Controle de NF-e"
                  bgcolor="primary"
                  hovercolor="tertiary"
                  onClick={() => {
                    clearNfe();

                    const openedBySalesOrder = !!queryString.parse(
                      window?.location?.search
                    )?.tempParam_operation;

                    if (openedBySalesOrder) {
                      const link =
                        queryParams.current_url !== "localhost"
                          ? `https://${queryParams.current_url}.qyon.com`
                          : `http://localhost`;

                      window.parent.location.href = `${link}/zf/vendas/nfe`;
                    } else {
                      push("/financeiro/nfe/painel");
                    }
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={4}>
              <div style={{ height: 45, display: "flex" }}>
                <Btn
                  startIcon={<AddShoppingCartIcon />}
                  style={{ width: "100%", fontSize: "12px" }}
                  bgcolor="green"
                  label="Montagem Automática"
                  hovercolor="blue"
                  disabled={
                    nfeStatus !== "D" ||
                    nfeId ||
                    nfeMontageType === "A" ||
                    headerModel?.value !== "55"
                  }
                  onClick={() => setOpenAutomatic(true)}
                />
              </div>
            </Grid>
          </Grid>
        }
      />
      <NotaContainer maxWidth="xl">
        <StatusControl>
          <Card>
            <Grid container spacing={3}>
              <Grid item lg={7} sm={daysCertificate && queryParams.id ? 7 : 12}>
                {jsonNfSituation[nfeStatus]}
              </Grid>
              <Grid item sm={5}>
                <Chip
                  bgcolor={
                    daysCertificate && queryParams.id ? "tertiary" : "darkred"
                  }
                  textcolor="white"
                  label={
                    daysCertificate && queryParams.id
                      ? `Certificado Expira em  ${daysCertificate} Dias`
                      : `Certificado não encontrado. `
                  }
                />
              </Grid>
              <Grid item sm={12} lg={12}>
                <Grid container spacing={2}>
                  <Grid item lg={3} sm={3}>
                    <Btn
                      bgcolor="tertiary"
                      hovercolor="blue"
                      label="Download XML"
                      disabled={(nfeId ? false : true) || nfeStatus === "G"}
                      onClick={() =>
                        handleDownloadXmlNota([nfeId], setMainLoading)
                      }
                      full="true"
                    />
                  </Grid>
                  <Grid item lg={3} sm={3}>
                    <Btn
                      bgcolor="tertiary"
                      hovercolor="blue"
                      label="Imprimir"
                      onClick={() => {
                        handleDownloadDanfe(nfeId);
                      }}
                      disabled={(nfeId ? false : true) || nfeStatus === "G"}
                      full="true"
                    />
                  </Grid>
                  <Grid item lg={3} sm={3}>
                    <Btn
                      bgcolor="primary"
                      label="Carta de Correção"
                      full="true"
                      onClick={() => setOpenCC(true)}
                      disabled={!(nfeStatus === "R")}
                    />
                  </Grid>
                  <Grid item lg={3} sm={3}>
                    <Btn
                      bgcolor="red"
                      label="Cancelar NFe"
                      onClick={() => setOpenCancelNfe(true)}
                      disabled={!(nfeStatus === "R")}
                      full="true"
                      hovercolor="darkred"
                    />
                  </Grid>
                  <Grid item container spacing={2} xs={12}>
                    <Grid item xs>
                      <TextField
                        label={
                          headerTypeNfe?.value === "S"
                            ? `Data de Saída`
                            : `Data de Entrada`
                        }
                        type="date"
                        size="small"
                        setValue={setHeaderDateJL}
                        value={headerDateJL}
                        error={nfeError.headerDateJL ? true : false}
                        helperText={nfeError.headerDateJL || ""}
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item xs>
                      <InputTime
                        label={
                          headerTypeNfe?.value === "S"
                            ? `Hora de Saída`
                            : `Hora de Entrada`
                        }
                        value={headerTime}
                        setValue={setHeaderTime}
                        error={nfeError.headerTime ? true : false}
                        helperText={nfeError.headerTime || ""}
                        disabled={visualizationOnly}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {nfeStatus !== "R" && nfeValidXml && (
                <Grow in={true}>
                  <Grid item xs={12}>
                    <Chip
                      bgcolor="orange"
                      textcolor="white"
                      label={nfeValidXml}
                    />
                  </Grid>
                </Grow>
              )}
              {nfeStatus !== "R" && nfeLotes.length ? (
                nfeLotes.map((row) =>
                  row.pivot?.ds_resposta &&
                  row.pivot?.cd_resposta &&
                  !successStats.find((e) => e === row.pivot.cd_resposta) ? (
                    <Grow in={true}>
                      <Grid item xs={12} key={row.id}>
                        <Chip
                          bgcolor={nfeStatus === "G" ? "orange" : "darkred"}
                          textcolor="white"
                          label={row.pivot?.ds_resposta}
                        />
                      </Grid>
                    </Grow>
                  ) : (
                    <></>
                  )
                )
              ) : (
                <></>
              )}
            </Grid>
          </Card>
        </StatusControl>
        <Cabecalho>
          <AccordionEmissaoCabecalho />
        </Cabecalho>
        <Remetente>
          <AccordionEmissaoRemetente />
        </Remetente>
        <Itens>
          <AccordionEmissaoItens />
        </Itens>
        <Secundarios>
          <AccordionEmissaoSecundarios />
        </Secundarios>
        <MainActions>
          <Grid container spacing={2}>
            <Grid item sm></Grid>
            <Grid item>
              <Btn
                ref={saveButtonRef}
                label="Salvar"
                disabled={
                  nfeStatus === "R" ||
                  nfeStatus === "C" ||
                  nfeStatus === "G" ||
                  firstSaveDiBlock
                }
                bgcolor={nfeId ? "tertiary" : "primary"}
                hovercolor={nfeId ? "blue" : "orange"}
                onClick={handleSaveNota}
              />
            </Grid>
            <Grid item>
              <Tooltip
                title={
                  queryParams.empresa_cnpj?.endsWith("_democ")
                    ? "Não permitido em ambiente de treinamento"
                    : ""
                }
                placement="top"
              >
                <span>
                  <Btn
                    label="Transmitir"
                    disabled={
                      queryParams.empresa_cnpj?.endsWith("_democ") ||
                      nfeStatus === "R" ||
                      !nfeId ||
                      nfeStatus === "C" ||
                      nfeStatus === "G" ||
                      nfeValidXml
                    }
                    onClick={() => {
                      handleTransmitNfe(nfeId);
                    }}
                  />
                </span>
              </Tooltip>
            </Grid>
          </Grid>
        </MainActions>
      </NotaContainer>
    </>
  );
};

export default EmissaoView;
